import styled from 'styled-components'

import {Typography} from '~/components/general/typography/Typography'

export const QuestionnairesSidebarTitle = styled(Typography)`
  margin-bottom: ${({theme}) => theme.spacing.xs};
`
